import { GeoDistanceFillgridFilter } from '../Fillgrid'

enum SearchDateType {
  RECEIVED = 'receivedDate',
  CREATION = 'creationDate'
}

enum SearchStatus {
  OUT = 'OUT',
  SNT = 'SNT',
  RVD = 'RVD',
  FNL = 'FNL'
}

enum SearchLocation {
  IN = 'in-site',
  OUT = 'out-site'
}

enum SearchOrigin {
  DATAFEED = 'DATAFEED',
  FILLGRID = 'FILL_GRID',
  TEMPORAL = 'TEMPORAL_SEARCH'
}
class CustomSearch {
  id: number
  name: string
  status?: SearchStatus
  worked?: boolean
  user?: string[]
  altUser?: string[]
  ident0?: string[]
  ident1?: string[]
  ident2?: string[]
  locationStatus?: SearchLocation[]
  view?: number
  origin: SearchOrigin
  from?: string
  to?: string
  dateType?: SearchDateType
  values?: string
  fullValues?: string
  geoDistance?: GeoDistanceFillgridFilter
  creationDate: Date
  updateDate: Date

  static getInstance () {
    const search = new CustomSearch()
    search.id = -1
    search.name = 'New Search'
    search.origin = SearchOrigin.FILLGRID
    return search
  }

  static searchHasIdent (search: CustomSearch, identIndex: number) {
    switch (identIndex) {
      case 0:
        return search.ident0 !== undefined && search.ident0.length > 0
      case 1:
        return search.ident1 !== undefined && search.ident1.length > 0
      case 2:
        return search.ident2 !== undefined && search.ident2.length > 0
      default:
        return false
    }
  }
}

export { CustomSearch, SearchOrigin, SearchDateType }
